import type {
  DemoRegisterExpeditorRequest,
  LoginRequest,
  MeResponse,
  RegisterClientRequest,
  RegisterClientResponse,
  TokenPair,
} from '@expeditor/shared';
import { apiClient } from './client';

export const authApi = {
  async login(dto: LoginRequest): Promise<TokenPair> {
    const { data } = await apiClient.post<TokenPair>('/auth/login', dto);
    return data;
  },
  async register(dto: RegisterClientRequest): Promise<RegisterClientResponse> {
    const { data } = await apiClient.post<RegisterClientResponse>('/auth/register', dto);
    return data;
  },
  /** Демо-стенд: включён ли демо-режим на этом инстансе. */
  async demoStatus(): Promise<{ demoMode: boolean }> {
    const { data } = await apiClient.get<{ demoMode: boolean }>('/auth/demo/status');
    return data;
  },
  /** Демо-стенд: само-регистрация сотрудника-экспедитора (MANAGER). */
  async registerDemoExpeditor(
    dto: DemoRegisterExpeditorRequest,
  ): Promise<RegisterClientResponse> {
    const { data } = await apiClient.post<RegisterClientResponse>(
      '/auth/demo/register-expeditor',
      dto,
    );
    return data;
  },
  /** Демо-стенд: сотрудник заводит своего демо-клиента (виден только ему). */
  async createDemoClient(dto: RegisterClientRequest): Promise<RegisterClientResponse> {
    const { data } = await apiClient.post<RegisterClientResponse>(
      '/auth/demo/create-client',
      dto,
    );
    return data;
  },
  async me(): Promise<MeResponse> {
    const { data } = await apiClient.get<MeResponse>('/auth/me');
    return data;
  },
  async logout(refreshToken: string): Promise<void> {
    await apiClient.post('/auth/logout', { refreshToken });
  },
  async verifyEmail(token: string): Promise<{ verified: true }> {
    const { data } = await apiClient.get<{ verified: true }>(
      `/auth/verify-email?token=${encodeURIComponent(token)}`,
    );
    return data;
  },
  async resendVerification(): Promise<{ ok: true }> {
    const { data } = await apiClient.post<{ ok: true }>('/auth/resend-verification');
    return data;
  },
  async requestPasswordReset(email: string): Promise<{ ok: true }> {
    const { data } = await apiClient.post<{ ok: true }>('/auth/request-password-reset', {
      email,
    });
    return data;
  },
  async resetPassword(token: string, newPassword: string): Promise<{ ok: true }> {
    const { data } = await apiClient.post<{ ok: true }>('/auth/reset-password', {
      token,
      newPassword,
    });
    return data;
  },
};
